export interface AssessmentQuestion {
    id: number
    setId: number
    questionType: QuestionType
    answerType: AnswerType
    questionDesc: string
    desc: string
    explanation: string
    illustrationUrl: string
    choices: AssessmentChoice[]
    point: number
    questionTime: number
    totalCorrectAnswer: number
    itemType: ItemType | null
    imageUrl: string | null
}

export interface AssessmentChoice {
    id: number
    content: string
    answerUrl: string
    isCorrect: number
}

export interface AssessmentAnswer {
    id: number
    type: AssessmentType
    startTime: number
    endTime: number
    correctAnswers: string[]
    answer: AssessmentAnswerDetail[]
}

export interface AssessmentAnswerDetail {
    answer: string
    isCorrect: number
    point: number
}

export enum AssessmentType {
    QUIZ = 'quiz',
    LECTURE = 'lecture'
}

export enum QuestionType {
    SINGLE_CHOICE = 'sca',
    MULTIPLE_CHOICE = 'mca',
    FILL_IN_BLANK = 'gap',
}
export enum AnswerType {
    TEXT = 'text',
    IMAGE = 'image',
    AUDIO = 'audio',
}

export enum ItemType {
    VIDEO = 'video',
    AUDIO = 'audio',
    IMAGE = 'image'
}

export enum ThemeType {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    SUCCESS = 'success',
    DANGER = 'danger',
    WARNING = 'warning',
    INFO = 'info',
    LIGHT = 'light',
    DARK = 'dark',
    LINK = 'link',
}

export enum AnswerResultType {
    CORRECT = 'corrected',
    INCORRECT = 'incorrected',
    ALMOST_CORRECT = 'almost_corrected',

}

export enum CountdownType {
    CIRCULAR = 'Circular',
    BAR = 'bar'
}